var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBtnBrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#CE6605"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22001 5.21995C8.36064 5.0795 8.55126 5.00061 8.75001 5.00061C8.94876 5.00061 9.13939 5.0795 9.28001 5.21995L13.53 9.46995C13.6705 9.61058 13.7494 9.8012 13.7494 9.99995C13.7494 10.1987 13.6705 10.3893 13.53 10.53L9.28001 14.78C9.13784 14.9124 8.94979 14.9846 8.75549 14.9811C8.56119 14.9777 8.3758 14.899 8.23839 14.7616C8.10098 14.6242 8.02226 14.4388 8.01884 14.2445C8.01541 14.0502 8.08753 13.8621 8.22001 13.72L11.94 9.99995L8.22001 6.27995C8.07956 6.13933 8.00067 5.9487 8.00067 5.74995C8.00067 5.5512 8.07956 5.36058 8.22001 5.21995Z",
    fill: "#F6F3ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBtnBrown);
export default __webpack_public_path__ + "static/media/arrowBtnBrown.7949103576a647a5731a598ee8bfd0e5.svg";
export { ForwardRef as ReactComponent };